import { OtherTask } from 'src/app/model/task-list/other-task';
import { OfflineTaskChangesObject } from 'src/app/services/placer-offline-changes/task/offline-storage/offline-task-changes-object';
import PlacerPlanningViewGeneralTaskHelper from './placer-planning-view-general-task-helper';

export default class PlacerPlanningViewOtherTaskHelper {
  private constructor() {}

  public static preprocessOtherTask(
    task: OtherTask,
    taskIdToChanges: Map<number, OfflineTaskChangesObject>
  ): void {
    PlacerPlanningViewGeneralTaskHelper.fillOfflineTaskInfo(
      task,
      taskIdToChanges
    );
    PlacerPlanningViewGeneralTaskHelper.preprocessTimeBudgettedTask(task);
  }
}
